
export default function Footer() {
  return (
    <footer className="bg-[#2D3436] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://static.readdy.ai/image/2b1409af55cbbc24ae624602859a344f/49982b335b96708abcb5cab4610886b0.png"
              alt="KGM Danışmanlık"
              className="h-12 mb-6 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Sanayi, ihracat ve kalite süreçlerinin tek çözüm ortağı. Endüstriyel çözüm merkezi.
            </p>
            <div className="flex gap-4">
              <a
                href="https://wa.me/905543791632"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#C17F59] transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a
                href="mailto:kgmdanismanlik@gmail.com"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#C17F59] transition-colors cursor-pointer"
                aria-label="E-posta"
              >
                <i className="ri-mail-line text-xl"></i>
              </a>
              <a
                href="tel:+905543791632"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#C17F59] transition-colors cursor-pointer"
                aria-label="Telefon"
              >
                <i className="ri-phone-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Hizmetler */}
          <div>
            <h3 className="text-lg font-bold mb-6">Hizmetlerimiz</h3>
            <ul className="space-y-3">
              <li>
                <a href="#hizmetler" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  Devlet İzinleri
                </a>
              </li>
              <li>
                <a href="#hizmetler" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  Ürün Belgelendirme
                </a>
              </li>
              <li>
                <a href="#hizmetler" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  Yatırım Danışmanlığı
                </a>
              </li>
              <li>
                <a href="#hizmetler" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  ISO Standartları
                </a>
              </li>
              <li>
                <a href="#hizmetler" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  Yazılım Çözümleri
                </a>
              </li>
              <li>
                <a href="#hizmetler" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  Kalibrasyon
                </a>
              </li>
            </ul>
          </div>

          {/* Kurumsal */}
          <div>
            <h3 className="text-lg font-bold mb-6">Kurumsal</h3>
            <ul className="space-y-3">
              <li>
                <a href="#hakkimizda" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  Hakkımızda
                </a>
              </li>
              <li>
                <a href="#neden-biz" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  Neden Biz
                </a>
              </li>
              <li>
                <a href="#iletisim" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  İletişim
                </a>
              </li>
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h3 className="text-lg font-bold mb-6">İletişim</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#C17F59] mt-1 flex-shrink-0"></i>
                <span className="text-gray-400 text-sm">Konya, Türkiye</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-[#C17F59] mt-1 flex-shrink-0"></i>
                <a href="tel:+905543791632" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  +90 554 379 16 32
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-[#C17F59] mt-1 flex-shrink-0"></i>
                <a href="mailto:kgmdanismanlik@gmail.com" className="text-gray-400 hover:text-[#C17F59] transition-colors text-sm cursor-pointer">
                  kgmdanismanlik@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 KGM Danışmanlık. Tüm hakları saklıdır.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#C17F59] text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
